import React from "react";
import { Form, Modal, Row } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import {
  GetMedcDetails,
  AddMedcInfl,
  DeleteMedcInfl,
  UpdateMedcInfl,
} from "../../../../api/User/ACG/MEDCInflationApi";
import CustomButton from "../../../../components/common/CustomButton";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import toastFile from "../../../../Service/ToastFile";
import CustomInputField from "../../../../components/common/CustomInputField";

const schema = Yup.object().shape({
  medC_Inflation: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter MEDC Inflation"),
});

const MEDCInflation = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isGetData, setIsGetData] = useState(false);
  const [witchAction, setWitchAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [inputValue, setInputValue] = useState();
  const [selectedRow, setSelectedRow] = useState(null);

  const buttonRef = useRef(null);
  const column = [
    {
      title: "MEDC Inflation",
      field: "medC_Inflation",
      render: (rowData) => (+rowData.medC_Inflation * 100).toFixed(2) + "%",
      customFilterAndSearch: (query, rowData) => {
        const searchText = query.toLowerCase();
        const processedData = (+rowData.medC_Inflation * 100).toFixed(2) + "%";
        return processedData.toLowerCase().includes(searchText);
      },
    },
  ];

  useEffect(() => {
    getMEDCInflationData();
  }, []);

  useEffect(() => {
    if (witchAction === "update") {
      setInputValue(+selectedRowData?.medC_Inflation);
    } else {
      setInputValue();
    }
    if (showModal === false) {
      setSelectedRowData(null);
    }
    if (isGetData) {
      getMEDCInflationData();
    }
    setIsGetData(false);
  }, [showModal]);

  const getMEDCInflationData = () => {
    setIsLoading(true);
    GetMedcDetails()
      .then((res) => {
        if(res.status === 200 || res.status === 204){
        setData(res.data);
        }
      })
      .catch((err) => console.log({ err }))
      .finally((res) => setIsLoading(false));
  };

  const handleActions = (values) => {
    const { medC_Inflation } = values;
    setInputValue(medC_Inflation);
    buttonRef.current.disabled = true;

    if (witchAction === "add") {
      const payload = { id: 0, medC_Inflation: +medC_Inflation };
      AddMedcInfl(payload).then((res) => {
        if(res.status === 200 || res.status === 204){
        toastFile("new");
        setIsGetData(true);
        setShowModal(false);
        }
      });
    } else if (witchAction === "update") {
      setWitchAction("updateYesNo");
    }
  };

  const updateMedcInfl = (check) => {
    let payload = {
      id: selectedRowData.id,
      medC_Inflation: +inputValue,
      check: check,
    };

    UpdateMedcInfl(selectedRowData.id, payload).then((res) => {
      if(res.status === 200 || res.status === 204){
      toastFile("update");
      setIsGetData(true);
      setShowModal(false);
      }
    });
    setInputValue();
  };

  return (
    <div>
      <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered={witchAction !== "delete"}
      >
        <Modal.Header
          closeButton
          onHide={() => {
            setShowModal(false);
            setInputValue();
          }}
        >
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            {witchAction === "add"
              ? "Add "
              : witchAction === "update" ||
                witchAction === "updateYesNo" ||
                witchAction === "updateNegativeYesNo"
              ? "Update "
              : "Delete "}
            MEDC Inflation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            validationSchema={schema}
            onSubmit={handleActions}
            initialValues={{
              medC_Inflation: (
                +(selectedRowData?.medC_Inflation ?? 0)
              ),
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              touched,
              errors,
            }) => (
              <Form onSubmit={handleSubmit}>
                {witchAction === "delete" ||
                witchAction === "updateYesNo" ||
                witchAction === "updateNegativeYesNo" ? (
                  <div className="text-wrap">
                    {witchAction === "delete"
                      ? "Are you sure that you want to delete the record?"
                      : witchAction === "updateYesNo"
                      ? "You have updated MEDC Inflation Rate, do you want to recalculate MEDC by Gender rates?"
                      : "The MEDC Inflation rate is less than 0, are you trying to undo your last calculation due to an mistake ?"}
                  </div>
                ) : (
                  <Row className="mb-2 gap-3">
                    <CustomInputField
                      label="Core-Based Statistical Area (MEDC Inflation)"
                      name="medC_Inflation"
                      maxLength={10}
                      value={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      isRequired
                    />
                  </Row>
                )}
                <div>
                  {witchAction === "delete" ||
                  witchAction === "updateYesNo" ||
                  witchAction === "updateNegativeYesNo" ? (
                    <div>
                      <div className="d-flex align-items-center justify-content-end gap-3 my-4">
                        <button
                          style={Fontstyling.savebutton}
                          onClick={() => {
                            if (witchAction === "delete") {
                              DeleteMedcInfl(selectedRowData?.id).then(
                                (res) => {
                                  if(res.status === 200 || res.status === 204){
                                  toastFile("delete");
                                  setShowModal(false);
                                  let deletedata = data.filter(
                                    (item, index) =>
                                      selectedRowData?.tableData.id !== index
                                  );
                                  setData(deletedata);
                                  }
                                }
                              );
                            } else if (witchAction === "updateYesNo") {
                              if (inputValue < 0) {
                                setWitchAction("updateNegativeYesNo");
                              } else updateMedcInfl(2);
                            } else updateMedcInfl(3);
                          }}
                        >
                          Yes
                        </button>
                        <button
                          style={Fontstyling.cancelbutton}
                          onClick={() => {
                            setShowModal(false);
                            if (witchAction === "updateYesNo") {
                              if (inputValue < 0) {
                                setWitchAction("updateNegativeYesNo");
                              } else updateMedcInfl(1);
                            } else updateMedcInfl(4);
                          }}
                        >
                          No
                        </button>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="d-flex align-items-center justify-content-end gap-3 my-4">
                        <button
                          ref={buttonRef}
                          style={Fontstyling.savebutton}
                          type="submit"
                        >
                          save
                        </button>
                        <button
                          style={Fontstyling.cancelbutton}
                          type="reset"
                          onClick={() => setShowModal(false)}
                        >
                          Cancel
                        </button>
                      </div>
                      <span className="text-success" style={{fontSize:"12px"}}>
                        * No special characters are allowed
                      </span>
                    </>
                  )}
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
      {/* <div className="text-end py-3 border-bottom">
        <CustomButton
          onClick={() => {
            setWitchAction("add");
            setShowModal(true);
          }}
        >
          Add MEDC Inflation
        </CustomButton>
      </div> */}
      <CustomMaterialTable
        isDelete={false}
        column={column}
        data={data}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={setWitchAction}
        setSelectedRowData={setSelectedRowData}
        setShowModal={setShowModal}
        isLoading={isLoading}
      />
    </div>
  );
};

export default MEDCInflation;
